import { ScrollTrigger } from '../../libs/gsap/ScrollTrigger';
import { MOBILMEDIA } from '../helper/constants';
import { $, debounce, isDebug } from '../helper/utils';
import Snow from './snow/snowgl';

gsap.registerPlugin(ScrollTrigger);

const main = $('main');
const header = $('#header');
const footer = $('#footer');
const debug = {};

if (isDebug()) {
  debug.markers = true;
}

// let it snow
const snowElement = $('.let-it-snow');
if (snowElement !== null) {
  const snowScene = Snow(snowElement);
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0,
  };

  const observer = new IntersectionObserver((entries) => {
    for (const el of entries) {
      if (el.rootBounds !== null) {
        if (el.isIntersecting === true) {
          snowScene.play();
        } else {
          snowScene.pause();
        }
      }
    }
  }, observerOptions);

  observer.observe(snowElement);
}

// create main background element and append
const mainBg = document.createElement('div');
mainBg.className = 'teaser-fc-bg';
main.appendChild(mainBg);

// needed for styling, as ~ selector won't work anymore once teaser element is pinned
document.body.classList.add('has-teaser-fc');

// scroll trigger controlling teaser pinning
ScrollTrigger.create({
  ...debug,
  id: 'scroll-pin',
  trigger: document.body,
  start: 'top top',
  pin: '.teaser-fullscreen',
  pinSpacing: false,
  end: () => `+=${window.innerHeight * 0.8}`,
  onLeave() {
    header.classList.add('bg');
  },
  onEnterBack() {
    header.classList.remove('bg');
  },
});

const startTl = gsap.timeline({
  paused: true,
});

startTl
  .to(header, {
    duration: 0.425,
    opacity: 1,
    ease: 'sine-out',
  })
  .fromTo('.teaser-fullscreen .container', {
    yPercent: 25,
  }, {
    duration: 0.475,
    opacity: 1,
    yPercent: 0,
    ease: 'sine-out',
  }, '<+0.1')
  .set(mainBg, { opacity: 1 }, '<+0.1')
  .fromTo([main, footer], {
    y: '20vh',
  }, {
    duration: 0.5,
    opacity: 1,
    y: 0,
    ease: 'sine-out',
  }, '<');

// specific for faltpackung banner
if ($('.teaser-fullscreen-falt-packages') !== null) {
  startTl
    .fromTo('.teaser-fullscreen-falt-packages picture', {
      yPercent: 100,
      xPercent: gsap.utils.wrap([50, 30, -30, -50]),
      rotation: gsap.utils.wrap([-8, -2, 2, 8]),
    }, {
      duration: 0.8,
      yPercent: gsap.utils.wrap([6, 0, 0, 6]),
      xPercent: gsap.utils.wrap([47, 15, -15, -47]),
      rotation: gsap.utils.wrap([-15, -5, 5, 15]),
      ease: 'power1.out',
    });
  // .to('.teaser-fullscreen-falt-packages picture', {
  //   duration: 0.8,
  //   xPercent: gsap.utils.wrap([47, 15, -15, -47]),
  //   rotation: gsap.utils.wrap([-15, -5, 5, 15]),
  //   ease: 'expo.out',
  // }, '<+0.4');
}

startTl.play();

(function clip() {
  let clippingTween;
  const clipPath = {
    mobile: 'inset(0% 0px 500px)',
    default: () => {
      const ww = window.innerWidth;
      const mainHeight = main.offsetHeight;
      const paddingTop = parseInt(window.getComputedStyle(main).paddingTop, 10);
      const paddingLeft = parseInt(window.getComputedStyle($('.container')).paddingLeft, 10);

      // clip to the container's padding
      return `
        inset(${((paddingTop - paddingLeft) / mainHeight) * 100}% ${ww / 2 - $('.container').offsetWidth / 2}px 500px)
      `.trim();
    },
  };

  // tween controlling main bg clipping
  const clipTweenOptions = {
    clipPath: 'inset(0% 0px 500px)',
    startAt: {
      clipPath: MOBILMEDIA.matches ? clipPath.mobile : clipPath.default(),
    },
    scrollTrigger: {
      ...debug,
      id: 'main-clip',
      trigger: document.body,
      start: 'top top',
      scrub: 0.5,
      end: () => `+=${window.innerHeight * 0.1}`,
    },
  };

  const onReverseComplete = function () {
    if (MOBILMEDIA.matches) {
      return;
    }

    // get newest clip values
    const startClip = clipPath.default();

    // current tween clip value not same as newest
    if (this.vars.startAt.clipPath !== startClip) {
      // kill anything tween related
      clippingTween.kill();
      ScrollTrigger.getById('main-clip')?.kill();
      clippingTween.eventCallback('onReverseComplete', null);

      // tween to correct value
      gsap.to(mainBg, { duration: 0.05, clipPath: startClip });

      // set updated tween
      setTimeout(() => {
        clippingTween = gsap.to(mainBg, {
          ...clipTweenOptions,
          startAt: {
            clipPath: MOBILMEDIA.matches ? clipPath.mobile : startClip,
          },
          onReverseComplete,
        });
      }, 50);
    }
  };

  clippingTween = gsap.to(mainBg, {
    ...clipTweenOptions,
    onReverseComplete,
  });

  const scroll = debounce(() => {
    // kill anything tween related
    clippingTween.kill();
    ScrollTrigger.getById('main-clip')?.kill();
    clippingTween.eventCallback('onReverseComplete', null);
    gsap.set(mainBg, { clearProps: 'clipPath' });

    // set updated tween
    requestAnimationFrame(() => {
      clippingTween = gsap.to(mainBg, {
        ...clipTweenOptions,
        startAt: {
          clipPath: MOBILMEDIA.matches ? clipPath.mobile : clipPath.default(),
        },
        onReverseComplete,
      });
    });
  }, 200);

  window.addEventListener('resize', scroll);
}());
